// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.background-overlay {
  display: flex;
  flex-direction: column;
  z-index: 98;
  background-color: rgba(224, 224, 224, 0.5);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  position: fixed;
  top: 0;
  left: 0;
  width: 100dvw;
  height: 100dvh;
  align-items: center;
  justify-content: center;
}

.download-dialog-container {
  height: -moz-fit-content;
  height: fit-content;
  max-height: 80dvh;
  width: 70dvw;
  border-radius: 50px;
  background: white;
  box-shadow: 20px 20px 20px #d9d9d9, -20px -20px 20px #e0e0e0;
  z-index: 99;
  padding: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.download-dialog-header .x-button {
  cursor: pointer;
  z-index: 9999;
}
.download-dialog-header .x-button:hover {
  color: #333;
}

.download-dialog-header .x-button {
  position: absolute;
  font-size: 1.25rem;
  top: 0.2rem;
  left: 0.2rem;
  background: none;
  color: grey;
  border: none;
}

/** Colors variables */
.sb-default .sb-wrapper {
  --sb-color: #fff;
  --sb-background: var(--button-color);
  --sb-border-radius: 4px;
  --sb-overflow: hidden;
}
.sb-default .sb-wrapper.sb-show-icon.sb-show-text {
  --sb-text-padding: 0 1em 0 0;
}
.sb-default .sb-wrapper.sb-show-icon.sb-show-text .sb-text {
  filter: none;
}

/** Colors variables */
.sb-circles-dark .sb-wrapper, .sb-circles-light .sb-wrapper {
  --sb-color: #fff;
  --sb-background: transparent;
  --sb-min-width: fit-content;
  --sb-height: fit-content;
  --sb-icon-size: 1.4em;
}
.sb-circles-dark .sb-wrapper:active .sb-icon, .sb-circles-light .sb-wrapper:active .sb-icon {
  box-shadow: 0 7px 8px -4px rgba(0, 0, 0, 0.2), 0 12px 17px 2px rgba(0, 0, 0, 0.14), 0 5px 22px 4px rgba(0, 0, 0, 0.12);
}
.sb-circles-dark .sb-wrapper .sb-icon, .sb-circles-light .sb-wrapper .sb-icon {
  background-color: var(--button-color);
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 2.5em;
  min-height: 2.5em;
  border-radius: 50%;
  transition: background 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
}
.sb-circles-dark .sb-wrapper .sb-text, .sb-circles-light .sb-wrapper .sb-text {
  color: var(--button-color);
  font-size: 0.8em;
  margin-top: 5px;
  border-radius: 1em;
  width: 100%;
  height: 1.8em;
  line-height: 1.8em;
  padding: 0;
  transition: background 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
}
.sb-circles-dark .sb-wrapper .sb-content, .sb-circles-light .sb-wrapper .sb-content {
  align-items: center;
  flex-direction: column;
}

.sb-circles-dark .sb-wrapper .sb-icon {
  background-color: var(--button-color);
}
.sb-circles-dark .sb-wrapper .sb-text {
  color: var(--button-color);
}

.sb-circles-light .sb-wrapper .sb-icon, .sb-circles-light .sb-wrapper .sb-text {
  color: var(--button-color);
}
.sb-circles-light .sb-wrapper .sb-icon {
  background: radial-gradient(ellipse farthest-corner at center, white 30%, #f2f2f2 100%);
}

/* You can add global styles to this file, and also import other style files */
body, html {
  height: 100vh;
  margin: 0;
}

body {
  font-family: Arial, sans-serif;
  height: 100vh;
  background-color: #fff; /* Background color for the top half */
  position: relative;
  display: block;
  justify-content: center;
  align-items: center;
}

body::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50%;
  background: #fff;
  z-index: -1; /* Ensure the gradient is behind other content */
}

/* Old palette
\$theme-main: #B05995;
\$theme-contrast: #3792BF;
\$theme-1: #282B59;
\$theme-2: #D683DD;
\$theme-3: #27567A;
\$theme-4: #44DDC4;
\$theme-5: #3336AE;
\$theme-6: #18C43D;
*/
.material-symbols-outlined {
  cursor: pointer;
  font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 48;
}

p {
  font-family: Arial, Helvetica, sans-serif;
  text-align: justify;
  color: #2D2D2A;
}

html, body {
  height: 100%;
}

body {
  margin: 0;
  font-family: Roboto, "Helvetica Neue", sans-serif;
}

.generic-button, .generic-button-alt {
  color: white;
  border-radius: 5px; /* Rounded corners */
  padding: 10px 20px; /* Padding for button size */
  margin-right: 10px;
  cursor: pointer; /* Pointer on hover */
  transition: background-color 0.3s; /* Smooth transition on hover */
}
.generic-button p, .generic-button-alt p {
  color: white;
  margin: 0;
}

.generic-button {
  background-color: #1B3E78; /* Button background color */
  border: 2px solid #1B3E78; /* No border */
}

.generic-button-alt {
  background-color: #0CAD99; /* Button background color */
  border: 2px solid #0CAD99; /* No border */
}

.generic-button:hover {
  background-color: #fff; /* Change color on hover */
  color: #1B3E78;
}
.generic-button:hover p {
  color: #1B3E78;
}

.generic-button-alt:hover {
  background-color: #fff; /* Change color on hover */
  color: #0CAD99;
}
.generic-button-alt:hover p {
  color: #0CAD99;
}

.generic-button:disabled, .generic-button-alt:disabled {
  background-color: #e7e7e7;
  border-color: #e7e7e7;
  cursor: not-allowed;
}

.download-dialog-container {
  width: 50dvw;
}

.download-dialog-header {
  position: relative;
  text-align: center;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.download-dialog-header h1 {
  font-size: 25px;
  font-weight: normal;
  margin: 0 20px;
  text-align: center;
}
.download-dialog-body {
  display: flex;
  flex-direction: column;
  min-height: 20dvh;
  justify-content: center;
  align-items: center;
}
.download-dialog-body app-loader {
  align-items: center;
}
.download-dialog-body .download-columns-list {
  justify-content: center;
  align-items: center;
}

.download-dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
}
.download-dialog-footer .download-button-container {
  display: flex;
}
.download-dialog-footer .download-button-container .generic-button {
  margin: 10px;
  cursor: pointer;
}
.download-dialog-footer .download-button-container .generic-button:disabled {
  color: grey;
  cursor: not-allowed;
}

.echelon-card-container {
  flex-direction: row;
  flex-wrap: wrap;
  max-height: 28vh;
  width: 250px;
  overflow-y: scroll;
  justify-content: center;
  margin-bottom: 20px;
  /* Hide scrollbar for WebKit-based browsers (Chrome, Safari) */
  /* Hide scrollbar for Firefox */
  scrollbar-width: none;
  /* Hide scrollbar for Internet Explorer/Edge (legacy) */
  -ms-overflow-style: none;
}
.echelon-card-container::-webkit-scrollbar {
  display: none;
}

.echelon-card {
  display: flex;
  width: 200px;
  height: 20px;
  flex-direction: row;
  padding: 0 10px 0 10px;
  margin: 10px 10px 0 0;
  border-radius: 10px;
  background-color: white;
}

.echelon-card .card-content-container {
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: left;
  width: 200px;
  margin-left: 0px;
}
.echelon-card .card-content-container .echelon-name {
  font-size: 17px;
  margin: 0;
}

.subtext {
  font-size: 0.75rem;
  color: #666;
  margin: 10px 0;
}
.subtext--green {
  margin: 0;
  color: #0CAD99;
  font-size: 0.75rem;
}

.echelon-card input[disabled] + .card-content-container {
  opacity: 0.6;
}

.echelon-section {
  margin-bottom: 2rem;
}
.echelon-section h4 {
  margin-bottom: 0.5rem;
  font-weight: bold;
  border-bottom: 1px solid #ccc;
  padding-bottom: 0.3rem;
}

.tag {
  font-size: 0.75rem;
  color: #777;
  margin-left: 0.25rem;
}

.padlock-wrapper {
  position: relative;
}

.padlock-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  pointer-events: auto;
}

@media (max-width: 1000px) {
  .download-dialog-container {
    width: 70dvw;
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/placeholders/_quickStyles.scss","webpack://./src/app/shared/toolbox/dialogs/tabular-data-download-dialog/tabular-data-download-dialog.component.scss","webpack://./node_modules/ngx-sharebuttons/themes/variables.scss","webpack://./node_modules/ngx-sharebuttons/themes/default.scss","webpack://./node_modules/ngx-sharebuttons/themes/circles.scss","webpack://./src/styles.scss"],"names":[],"mappings":"AAMA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,0CAAA;EACA,kCAAA;UAAA,0BAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;ACLF;;ADQA;EACE,wBAAA;EAAA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,4DAAA;EAEA,WAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;ACNF;;ADUA;EACE,eAAA;EACA,aAAA;ACPF;ADSE;EACE,WAAA;ACPJ;;ADuBA;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;ACpBF;;AC7CA,sBAAA;ACEA;EACE,gBAAA;EACA,oCAAA;EACA,uBAAA;EACA,qBAAA;AF+CF;AE7CE;EACE,4BAAA;AF+CJ;AE7CI;EACE,YAAA;AF+CN;;AC3DA,sBAAA;AEME;EACE,gBAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,qBAAA;AHyDJ;AGtDM;EACE,sHAAA;AHwDR;AGpDI;EACE,qCAAA;EACA,iHAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,2GAAA;AHsDN;AGnDI;EACE,0BAAA;EACA,gBA3BS;EA4BT,eAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,2GAAA;AHqDN;AGlDI;EACE,mBAAA;EACA,sBAAA;AHoDN;;AG7CE;EACE,qCAAA;AHgDJ;AG7CE;EACE,0BAAA;AH+CJ;;AGzCE;EACE,0BAAA;AH4CJ;AGzCE;EACE,uFAAA;AH2CJ;;AIxGA,8EAAA;AAEA;EACA,aAAA;EAEA,SAAA;AJyGA;;AItGA;EACI,8BAAA;EACA,aAAA;EACA,sBAAA,EAAA,sCAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;AJyGJ;;AIrGA;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EAGA,WAAA,EAAA,gDAAA;AJsGJ;;AIjGA;;;;;;;;;CAAA;AA0CA;EAEI,eAAA;EACA,kEACI;AJkER;;AI5DA;EACI,yCAAA;EACA,mBAAA;EACA,cAxDS;AJuHb;;AI1DA;EAAa,YAAA;AJ8Db;;AI7DA;EAAO,SAAA;EAAW,iDAAA;AJkElB;;AI/DA;EACE,YAAA;EACA,kBAAA,EAAA,oBAAA;EACE,kBAAA,EAAA,4BAAA;EACA,kBAAA;EAGA,eAAA,EAAA,qBAAA;EACA,iCAAA,EAAA,+BAAA;AJgEJ;AI9DI;EACI,YAAA;EACA,SAAA;AJgER;;AI7DA;EACE,yBArEW,EAqEoB,4BAAA;EAC/B,yBAAA,EAAA,cAAA;AJgEF;;AI7DA;EACE,yBA7Da,EA6DoB,4BAAA;EACjC,yBAAA,EAAA,cAAA;AJgEF;;AI7DA;EACI,sBAAA,EAAA,0BAAA;EACA,cAhFS;AJgJb;AI9DI;EACI,cAnFK;AJmJb;;AI5DA;EACE,sBAAA,EAAA,0BAAA;EACA,cA5Ea;AJ2If;AI7DE;EACE,cA/EW;AJ8If;;AI3DA;EACI,yBA/Ec;EAgFd,qBAhFc;EAiFd,mBAAA;AJ8DJ;;AA3MA;EAEE,YAAA;AA6MF;;AA1MA;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AA6MF;AA3ME;EACE,eAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AA6MJ;AApMA;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;AAsMF;AApME;EACE,mBAAA;AAsMJ;AAnME;EACE,uBAAA;EACA,mBAAA;AAqMJ;;AAhMA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAmMF;AAjME;EACE,aAAA;AAmMJ;AAjMI;EACE,YAAA;EACA,eAAA;AAmMN;AAjMM;EACE,WAAA;EACA,mBAAA;AAmMR;;AA5LA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,8DAAA;EAKA,+BAAA;EACA,qBAAA;EAEA,uDAAA;EACA,wBAAA;AA0LF;AAlME;EACE,aAAA;AAoMJ;;AA1LA;EACE,aAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,uBAAA;AA6LF;;AAzLA;EACE,aAAA;EAEA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;AA2LF;AAzLE;EACE,eAAA;EACA,SAAA;AA2LJ;;AArLA;EACE,kBAAA;EACA,WAAA;EACA,cAAA;AAwLF;AAtLE;EACE,SAAA;EACA,cI9Ea;EJ+Eb,kBAAA;AAwLJ;;AApLA;EACE,YAAA;AAuLF;;AApLA;EACE,mBAAA;AAuLF;AArLE;EACE,qBAAA;EACA,iBAAA;EACA,6BAAA;EACA,sBAAA;AAuLJ;;AAnLA;EACE,kBAAA;EACA,WAAA;EACA,oBAAA;AAsLF;;AAnLA;EACE,kBAAA;AAsLF;;AAnLA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;AAsLF;;AAlLA;EAEE;IACE,YAAA;EAoLF;AACF","sourcesContent":["\n%max-HW-100 {\n  height: 100%;\n  width: 100%;\n}\n\n%full-screen-background-overlay {\n  display: flex;\n  flex-direction: column;\n  z-index: 98;\n  background-color: rgba(#e0e0e0, 0.5);\n  backdrop-filter: blur(4px);\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100dvw;\n  height: 100dvh;\n  align-items: center;\n  justify-content: center;\n}\n\n%white-background-raised-container {\n  height: fit-content;\n  max-height: 80dvh;\n  width: 70dvw;\n  border-radius: 50px;\n  background: white;\n  box-shadow: 20px 20px 20px #d9d9d9,\n  -20px -20px 20px #e0e0e0;\n  z-index: 99;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n// Base x-button style\n%x-button {\n  cursor: pointer;\n  z-index: 9999;\n\n  &:hover {\n    color: #333;\n  }\n}\n\n// Modifier: small\n%x-button--small {\n  position: absolute;\n  font-size: 0.75rem;\n  top: 0.5rem;\n  left: 14rem;\n  background: none;\n  color: grey;\n  border: none;\n}\n\n// Modifier: large\n%x-button--large {\n  position: absolute;\n  font-size: 1.25rem;\n  top: 0.2rem;\n  left: 0.2rem;\n  background: none;\n  color: grey;\n  border: none;\n}\n\n\n","@import \"../../../../../theme/placeholders/quickStyles\";\n@import '../../../../../styles';\n\n.background-overlay {\n  @extend %full-screen-background-overlay;\n}\n\n.download-dialog-container {\n  @extend %white-background-raised-container;\n  width: 50dvw;\n}\n\n.download-dialog-header {\n  position: relative;\n  text-align: center;\n  margin-bottom: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  h1 {\n    font-size: 25px;\n    font-weight: normal;\n    margin: 0 20px;\n    text-align: center;\n  }\n\n  .x-button {\n    @extend %x-button;\n    @extend %x-button--large;\n  }\n}\n\n.download-dialog-body {\n  display: flex;\n  flex-direction: column;\n  min-height: 20dvh;\n  justify-content: center;\n  align-items: center;\n\n  app-loader {\n    align-items: center;\n  }\n\n  .download-columns-list {\n    justify-content: center;\n    align-items: center;\n  }\n\n}\n\n.download-dialog-footer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  .download-button-container {\n    display: flex;\n\n    .generic-button {\n      margin: 10px;\n      cursor: pointer;\n\n      &:disabled {\n        color: grey;\n        cursor: not-allowed;\n      }\n    }\n\n  }\n}\n\n.echelon-card-container {\n  flex-direction: row;\n  flex-wrap: wrap;\n  max-height: 28vh;\n  width: 250px;\n  overflow-y: scroll;\n  justify-content: center;\n  margin-bottom: 20px;\n  /* Hide scrollbar for WebKit-based browsers (Chrome, Safari) */\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  /* Hide scrollbar for Firefox */\n  scrollbar-width: none;\n\n  /* Hide scrollbar for Internet Explorer/Edge (legacy) */\n  -ms-overflow-style: none;\n}\n\n.echelon-card {\n  display: flex;\n  width: 200px;\n  height: 20px;\n  flex-direction: row;\n  padding: 0 10px 0 10px;\n  margin: 10px 10px 0 0;\n  border-radius: 10px;\n  background-color: white;\n  //border: 2px solid $theme-main;\n}\n\n.echelon-card .card-content-container {\n  padding: 10px;\n\n  display: flex;\n  align-items: center;\n  justify-content: left;\n  width: 200px;\n  margin-left: 0px;\n\n  .echelon-name {\n    font-size: 17px;\n    margin: 0;\n\n  }\n\n}\n\n.subtext {\n  font-size: 0.75rem;\n  color: #666;\n  margin: 10px 0;\n\n  &--green {\n    margin: 0;\n    color: $theme-contrast;\n    font-size: 0.75rem;\n  }\n}\n\n.echelon-card input[disabled] + .card-content-container {\n  opacity: 0.6;\n}\n\n.echelon-section {\n  margin-bottom: 2rem;\n\n  h4 {\n    margin-bottom: 0.5rem;\n    font-weight: bold;\n    border-bottom: 1px solid #ccc;\n    padding-bottom: 0.3rem;\n  }\n}\n\n.tag {\n  font-size: 0.75rem;\n  color: #777;\n  margin-left: 0.25rem;\n}\n\n.padlock-wrapper {\n  position: relative; // important so absolute padlock fits this section only\n}\n\n.padlock-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 10;\n  pointer-events: auto;\n}\n\n\n@media (max-width: 1000px) {\n\n  .download-dialog-container {\n    width: 70dvw;\n  }\n}\n\n\n","/** Colors variables */\r\n\r\n$sb-primary: #2E4057 !default;\r\n$sb-accent: #fff !default;\r\n$sb-facebook: #4267B2 !default;\r\n$sb-twitter: #00acee !default;\r\n$sb-google: #db4437 !default;\r\n$sb-mix: #ff8226 !default;\r\n$sb-linkedin: #006fa6 !default;\r\n$sb-pinterest: #bd081c !default;\r\n$sb-reddit: #ff4006 !default;\r\n$sb-tumblr: #36465d !default;\r\n$sb-whatsapp: #25d366 !default;\r\n$sb-messenger: #0080FF !default;\r\n$sb-telegram: #0088cc !default;\r\n$sb-xing: #006567 !default;\r\n$sb-email: #FF961C !default;\r\n$sb-viber: #665ca7 !default;\r\n$sb-vk: #4C75A3 !default;\r\n$sb-copy: #607D8B !default;\r\n$sb-print: #765AA2 !default;\r\n$sb-sms: #20c16c !default;\r\n$sb-gray: #a5a5a5 !default;\r\n$sb-expand: #FF6651 !default;\r\n$sb-line: #00b900 !default;\r\n\r\n$sb-buttons: (\r\n  facebook: $sb-facebook,\r\n  twitter: $sb-twitter,\r\n  google: $sb-google,\r\n  mix: $sb-mix,\r\n  line: $sb-line,\r\n  linkedin: $sb-linkedin,\r\n  pinterest: $sb-pinterest,\r\n  reddit: $sb-reddit,\r\n  tumblr: $sb-tumblr,\r\n  whatsapp: $sb-whatsapp,\r\n  messenger: $sb-messenger,\r\n  telegram: $sb-telegram,\r\n  xing: $sb-xing,\r\n  sms: $sb-sms,\r\n  email: $sb-email,\r\n  viber: $sb-viber,\r\n  vk: $sb-vk,\r\n  copy: $sb-copy,\r\n  print: $sb-print,\r\n  expand: $sb-expand\r\n) !default;\r\n","@import \"variables\";\r\n\r\n.sb-default .sb-wrapper {\r\n  --sb-color: #{$sb-accent};\r\n  --sb-background: var(--button-color);\r\n  --sb-border-radius: 4px;\r\n  --sb-overflow: hidden;\r\n\r\n  &.sb-show-icon.sb-show-text {\r\n    --sb-text-padding: 0 1em 0 0;\r\n\r\n    .sb-text {\r\n      filter: none;\r\n    }\r\n  }\r\n}\r\n","@import \"variables\";\r\n\r\n$sb-text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);\r\n$sb-text-size: 0.8em;\r\n\r\n.sb-circles-dark, .sb-circles-light {\r\n  .sb-wrapper {\r\n    --sb-color: #{$sb-accent};\r\n    --sb-background: transparent;\r\n    --sb-min-width: fit-content;\r\n    --sb-height: fit-content;\r\n    --sb-icon-size: 1.4em;\r\n\r\n    &:active {\r\n      .sb-icon {\r\n        box-shadow: 0 7px 8px -4px rgba(0, 0, 0, .2), 0 12px 17px 2px rgba(0, 0, 0, .14), 0 5px 22px 4px rgba(0, 0, 0, .12);\r\n      }\r\n    }\r\n\r\n    .sb-icon {\r\n      background-color: var(--button-color);\r\n      box-shadow: 0 3px 5px -1px rgba(0, 0, 0, .2), 0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12);\r\n      width: 2.5em;\r\n      min-height: 2.5em;\r\n      border-radius: 50%;\r\n      transition: background .4s cubic-bezier(.25, .8, .25, 1), box-shadow 280ms cubic-bezier(.4, 0, .2, 1);\r\n    }\r\n\r\n    .sb-text {\r\n      color: var(--button-color);\r\n      font-size: $sb-text-size;\r\n      margin-top: 5px;\r\n      border-radius: 1em;\r\n      width: 100%;\r\n      height: 1.8em;\r\n      line-height: 1.8em;\r\n      padding: 0;\r\n      transition: background .4s cubic-bezier(.25, .8, .25, 1), box-shadow 280ms cubic-bezier(.4, 0, .2, 1);\r\n    }\r\n\r\n    .sb-content {\r\n      align-items: center;\r\n      flex-direction: column;\r\n    }\r\n  }\r\n}\r\n\r\n.sb-circles-dark .sb-wrapper {\r\n\r\n  .sb-icon {\r\n    background-color: var(--button-color);\r\n  }\r\n\r\n  .sb-text {\r\n    color: var(--button-color);\r\n  }\r\n}\r\n\r\n.sb-circles-light .sb-wrapper {\r\n\r\n  .sb-icon, .sb-text {\r\n    color: var(--button-color);\r\n  }\r\n\r\n  .sb-icon {\r\n    background: radial-gradient(ellipse farthest-corner at center, white 30%, darken(white, 5%) 100%);\r\n  }\r\n}\r\n","\n@import \"../node_modules/ngx-sharebuttons/themes/default.scss\";\n@import \"../node_modules/ngx-sharebuttons/themes/circles.scss\";\n\n/* You can add global styles to this file, and also import other style files */\n\nbody, html {\nheight: 100vh;\n// width: 100vh;\nmargin: 0;\n}\n\nbody {\n    font-family: Arial, sans-serif;\n    height: 100vh;\n    background-color: #fff; /* Background color for the top half */\n    position: relative;\n    display: block;\n    justify-content: center;\n    align-items: center;\n    }\n\n\nbody::after {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 50%;\n    background: #fff;\n\n\n    z-index: -1; /* Ensure the gradient is behind other content */\n}\n\n\n$theme-back: #2D2D2A;\n/* Old palette\n$theme-main: #B05995;\n$theme-contrast: #3792BF;\n$theme-1: #282B59;\n$theme-2: #D683DD;\n$theme-3: #27567A;\n$theme-4: #44DDC4;\n$theme-5: #3336AE;\n$theme-6: #18C43D;\n*/\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$theme-primary: #3792BF;\n$theme-secondary: #1B3E78;\n$theme-color3: #AACCFF;\n$theme-color4: #BDBDBD;\n$theme-color5: #7D7979;\n$theme-accent: #0CAD99;\n$text-gray:#787c95;\n$theme-red:#d9534f;\n\n$theme-back-light: #4c4c47;\n$theme-lightgray: #e7e7e7;\n$theme-gray-text: #787476;\n\n$theme-table-header: #f6f6f6;\n$theme-table-body:#f8f8f8;\n$theme-source:#9E9E9E;\n\n\n$value-chain-1: #44DDC4;\n$value-chain-2: \"\";\n$value-chain-3: \"\";\n$value-chain-4: \"\";\n\n.material-symbols-outlined {\n\n    cursor: pointer;\n    font-variation-settings:\n        'FILL' 0,\n        'wght' 400,\n        'GRAD' 0,\n        'opsz' 48;\n}\n\np {\n    font-family:Arial, Helvetica, sans-serif;\n    text-align: justify;\n    color: $theme-back;\n}\n\n\n\nhtml, body { height: 100%; }\nbody { margin: 0; font-family: Roboto, \"Helvetica Neue\", sans-serif; }\n\n\n.generic-button, .generic-button-alt {\n  color: white;\n  border-radius: 5px;   /* Rounded corners */\n    padding: 10px 20px;    /* Padding for button size */\n    margin-right: 10px;\n\n    // font-size: 16px;       /* Font size */\n    cursor: pointer;       /* Pointer on hover */\n    transition: background-color 0.3s; /* Smooth transition on hover */\n\n    p {\n        color:white;\n        margin:0;\n    }\n}\n.generic-button {\n  background-color: $theme-main; /* Button background color */\n  border: 2px solid $theme-main;      /* No border */\n}\n\n.generic-button-alt {\n  background-color: $theme-accent; /* Button background color */\n  border: 2px solid $theme-accent;      /* No border */\n}\n\n.generic-button:hover {\n    background-color: #fff; /* Change color on hover */\n    color: $theme-main;\n\n    p {\n        color: $theme-main\n    }\n}\n\n.generic-button-alt:hover {\n  background-color: #fff; /* Change color on hover */\n  color: $theme-accent;\n\n  p {\n    color: $theme-accent\n  }\n}\n\n.generic-button:disabled, .generic-button-alt:disabled {\n    background-color: $theme-lightgray;\n    border-color: $theme-lightgray;\n    cursor:not-allowed;\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
